import { Effect } from "../../Materials/effect";

let name = 'pbrFunctions';
let shader = `
#define RECIPROCAL_PI2 0.15915494
#define FRESNEL_MAXIMUM_ON_ROUGH 0.25

const float kRougnhessToAlphaScale=0.1;
const float kRougnhessToAlphaOffset=0.29248125;
float convertRoughnessToAverageSlope(float roughness)
{

const float kMinimumVariance=0.0005;
float alphaG=square(roughness)+kMinimumVariance;
return alphaG;
}

float smithVisibilityG1_TrowbridgeReitzGGX(float dot,float alphaG)
{
float tanSquared=(1.0-dot*dot)/(dot*dot);
return 2.0/(1.0+sqrt(1.0+alphaG*alphaG*tanSquared));
}
float smithVisibilityG_TrowbridgeReitzGGX_Walter(float NdotL,float NdotV,float alphaG)
{
return smithVisibilityG1_TrowbridgeReitzGGX(NdotL,alphaG)*smithVisibilityG1_TrowbridgeReitzGGX(NdotV,alphaG);
}


float normalDistributionFunction_TrowbridgeReitzGGX(float NdotH,float alphaG)
{



float a2=square(alphaG);
float d=NdotH*NdotH*(a2-1.0)+1.0;
return a2/(PI*d*d);
}
vec3 fresnelSchlickGGX(float VdotH,vec3 reflectance0,vec3 reflectance90)
{
return reflectance0+(reflectance90-reflectance0)*pow(clamp(1.0-VdotH,0.,1.),5.0);
}
vec3 fresnelSchlickEnvironmentGGX(float VdotN,vec3 reflectance0,vec3 reflectance90,float smoothness)
{

float weight=mix(FRESNEL_MAXIMUM_ON_ROUGH,1.0,smoothness);
return reflectance0+weight*(reflectance90-reflectance0)*pow(clamp(1.0-VdotN,0.,1.),5.0);
}

vec3 computeSpecularTerm(float NdotH,float NdotL,float NdotV,float VdotH,float roughness,vec3 reflectance0,vec3 reflectance90,float geometricRoughnessFactor)
{
roughness=max(roughness,geometricRoughnessFactor);
float alphaG=convertRoughnessToAverageSlope(roughness);
float distribution=normalDistributionFunction_TrowbridgeReitzGGX(NdotH,alphaG);
float visibility=smithVisibilityG_TrowbridgeReitzGGX_Walter(NdotL,NdotV,alphaG);
visibility/=(4.0*NdotL*NdotV);
float specTerm=max(0.,visibility*distribution)*NdotL;
vec3 fresnel=fresnelSchlickGGX(VdotH,reflectance0,reflectance90);
return fresnel*specTerm;
}
float computeDiffuseTerm(float NdotL,float NdotV,float VdotH,float roughness)
{


float diffuseFresnelNV=pow(clamp(1.0-NdotL,0.000001,1.),5.0);
float diffuseFresnelNL=pow(clamp(1.0-NdotV,0.000001,1.),5.0);
float diffuseFresnel90=0.5+2.0*VdotH*VdotH*roughness;
float fresnel =
(1.0+(diffuseFresnel90-1.0)*diffuseFresnelNL) *
(1.0+(diffuseFresnel90-1.0)*diffuseFresnelNV);
return fresnel*NdotL/PI;
}
float adjustRoughnessFromLightProperties(float roughness,float lightRadius,float lightDistance)
{
#if defined(USEPHYSICALLIGHTFALLOFF) || defined(USEGLTFLIGHTFALLOFF)

float lightRoughness=lightRadius/lightDistance;

float totalRoughness=clamp(lightRoughness+roughness,0.,1.);
return totalRoughness;
#else
return roughness;
#endif
}
float computeDefaultMicroSurface(float microSurface,vec3 reflectivityColor)
{
const float kReflectivityNoAlphaWorkflow_SmoothnessMax=0.95;
float reflectivityLuminance=getLuminance(reflectivityColor);
float reflectivityLuma=sqrt(reflectivityLuminance);
microSurface=reflectivityLuma*kReflectivityNoAlphaWorkflow_SmoothnessMax;
return microSurface;
}


float fresnelGrazingReflectance(float reflectance0) {
float reflectance90=clamp(reflectance0*25.0,0.0,1.0);
return reflectance90;
}


#define UNPACK_LOD(x) (1.0-x)*255.0
float getLodFromAlphaG(float cubeMapDimensionPixels,float alphaG,float NdotV) {
float microsurfaceAverageSlope=alphaG;






microsurfaceAverageSlope*=sqrt(abs(NdotV));
float microsurfaceAverageSlopeTexels=microsurfaceAverageSlope*cubeMapDimensionPixels;
float lod=log2(microsurfaceAverageSlopeTexels);
return lod;
}
float environmentRadianceOcclusion(float ambientOcclusion,float NdotVUnclamped) {


float temp=NdotVUnclamped+ambientOcclusion;
return clamp(square(temp)-1.0+ambientOcclusion,0.0,1.0);
}
float environmentHorizonOcclusion(vec3 view,vec3 normal) {

vec3 reflection=reflect(view,normal);
float temp=clamp( 1.0+1.1*dot(reflection,normal),0.0,1.0);
return square(temp);
}`;

Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var pbrFunctions = { name, shader };
